import { DatePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit
} from '@angular/core';

import { NgForm } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { AuthService, ProviderService } from '../../api';


import { Errors, unAvailability, unAvailabilityTiming } from '../../interfaces';
import { DecryptFormatPipe } from '../../pipes';
import { SnackService } from '../../services';

@Component({
  selector: 'school-customized-availability-form',
  templateUrl: './customized-availability-form.component.html',
  styleUrls: ['./customized-availability-form.component.scss'],
  providers: [DatePipe]
})
export class CustomizedAvailabilityFormComponent implements OnInit, OnDestroy, AfterViewInit {


  availabilityFormValue = {} as unAvailability;
  errMsg = {} as Errors;

  today = new Date();

  @Input() formtype: any;
  @Output() accordionEvent = new EventEmitter();
  @Output()
  cancelEvent = new EventEmitter<string>();

  @ViewChild('inputfocus', { static: false }) inputs: ElementRef;

  @ViewChild("availabilityform", { static: false }) availabilitysform: NgForm;

  user_id: string;

  constructor(
    private authService: AuthService,
    private _snackService: SnackService,
    private _userService: ProviderService,
    private route: ActivatedRoute,
    private _decryptPipe: DecryptFormatPipe,
    private datePipe: DatePipe,
  ) {

  }

  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get('userId')) {
      this.user_id = this._decryptPipe.transform(this.route.snapshot.paramMap.get('userId'));

      this.user_id = this.user_id ? (this.user_id).replace(/['"]+/g, '') : '';
    }

    this.availabilityFormValue.timing = {} as unAvailabilityTiming;

  }
  ngAfterViewInit() {
    this.inputs.nativeElement.focus();
  }



  ngOnDestroy(): void {
    this.accordionEvent.unsubscribe();
  }

  viewAvailabilitylist() {
    this.cancelEvent.emit();
  }


  checkTime(from_time, to_time) {
    var now = new Date();
    from_time = (now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + from_time;
    to_time = (now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + to_time;

    if (to_time > from_time || this.availabilityFormValue.to_date > this.availabilityFormValue.from_date) {
      return true;
    }
    else {
      return false;
    }
  }

  onSubmit(): void {

    if (this.user_id != undefined) {
      this.availabilityFormValue.provider_id = this.user_id;

    }

    const checkTimeValid = this.checkTime(this.availabilityFormValue.timing.from_time, this.availabilityFormValue.timing.to_time);

    if (checkTimeValid) {


      this.availabilityFormValue.from_date = this.datePipe.transform(this.availabilityFormValue.from_date, 'y-MM-dd');
      this.availabilityFormValue.to_date = this.datePipe.transform(this.availabilityFormValue.to_date, 'y-MM-dd');

      // const timeval = JSON.parse(localStorage.getItem('userData'));

      // this.availabilityFormValue.timing.tz = timeval.timezone.zone_name;

      this.authService.user.subscribe(user => {

        const timeval = user;
        this.availabilityFormValue.timing.tz = timeval.timezone.zone_name;
      });


      const saveData = { ...this.availabilityFormValue };

      this._userService.saveCustomizedavailability(saveData).subscribe(
        result => {

          this.availabilitysform.resetForm();
          this._snackService.openSnackBar("success", "Availability Added Successfully!...");
          this.errMsg = {};
          this.viewAvailabilitylist();

        }, error => {
          this._snackService.openSnackBar("danger", "Failed to add a new Availability...");
          this.errMsg = error.error.data.errors;
        });

    }
    else {
      this._snackService.openSnackBar("danger", "Invalid From time and To time...");

    }

  }


}
